<template>
  <div class="bill-config-content">
    <el-form :model="form" label-width="120px">
      <el-form-item label="选择伙伴" required>
        <el-select v-model="form.agent_id" placeholder="请选择伙伴" filterable>
          <el-option
            v-for="agent in agentList"
            :key="agent.id"
            :label="`${agent.company} (${agent.id})`"
            :value="agent.id"
          />
        </el-select>
      </el-form-item>
      
      <el-form-item label="账单地址">
        <el-input
          v-model="form.bill_address"
          type="textarea"
          :rows="3"
          placeholder="请输入账单地址"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
      
      <el-form-item label="上传LOGO">
        <el-upload
          ref="logoUploadRef"
          drag
          accept=".jpg,.jpeg,.png,.gif"
          :auto-upload="false"
          :on-change="handleLogoChange"
          :limit="1"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将LOGO文件拖到此处，或<em>点击上传</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持 JPG、PNG、GIF 格式，不超过 5MB
            </div>
          </template>
        </el-upload>
      </el-form-item>
    </el-form>
    
    <div class="dialog-footer">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="submitConfig" :loading="submitting">
        保存配置
      </el-button>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { UploadFilled } from '@element-plus/icons-vue'

export default {
  name: 'BillConfigContent',
  components: { UploadFilled },
  emits: ['success', 'cancel'],
  setup(props, { emit }) {
    const submitting = ref(false)
    const logoUploadRef = ref(null)
    const agentList = ref([])
    
    const form = reactive({
      agent_id: '',
      bill_address: '',
      logo_file: null
    })
    
    onMounted(() => {
      loadAgentList()
    })
    
    const loadAgentList = async () => {
      try {
        const response = await fetch('/api/bill/invoice-monitor/filter-options/')
        const data = await response.json()
        if (data.code === 200) {
          agentList.value = data.data.agent_list || []
        }
      } catch (error) {
        console.error('加载伙伴列表失败:', error)
      }
    }
    
    const handleLogoChange = (file) => {
      const isImage = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'].includes(file.raw.type)
      const isLt5M = file.size / 1024 / 1024 < 5
      
      if (!isImage) {
        ElMessage.error('只支持 JPG、PNG、GIF 格式的图片!')
        return false
      }
      if (!isLt5M) {
        ElMessage.error('图片大小不能超过 5MB!')
        return false
      }
      
      form.logo_file = file.raw
    }
    
    const submitConfig = async () => {
      if (!form.agent_id) {
        ElMessage.warning('请选择伙伴')
        return
      }
      
      submitting.value = true
      try {
        const formData = new FormData()
        formData.append('agent_id', form.agent_id)
        formData.append('bill_address', form.bill_address)
        if (form.logo_file) {
          formData.append('logo', form.logo_file)
        }
        
        const response = await fetch('/api/bill/config/save/', {
          method: 'POST',
          body: formData
        })
        
        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success('配置保存成功')
          emit('success')
        } else {
          ElMessage.error(data.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存配置失败:', error)
        ElMessage.error('保存失败，请重试')
      } finally {
        submitting.value = false
      }
    }
    
    return {
      form,
      agentList,
      submitting,
      logoUploadRef,
      handleLogoChange,
      submitConfig
    }
  }
}
</script>

<style lang="scss" scoped>
.bill-config-content {
  .dialog-footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
